import { render, staticRenderFns } from "./design-studio.vue?vue&type=template&id=5279970d&scoped=true&"
import script from "./design-studio.vue?vue&type=script&lang=js&"
export * from "./design-studio.vue?vue&type=script&lang=js&"
import style0 from "./design-studio.vue?vue&type=style&index=0&id=5279970d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279970d",
  null
  
)

export default component.exports